import { get, post } from '../https.js'

/**
  * 登记开发者账户（appId 唯一）
  * @param {*} data
  * @returns
  */
export const juliangDevAdd = (data) => post('/r4/juliang-dev/add', data)


/**
  * 开发者账户列表
  * @param {*} data
  * @returns
  */
export const juliangDevList = (data) => get('/r4/juliang-dev/list', data)


/**
  * 生成授权链接
  * @param {*} data
  * @returns
  */
export const juliangDevAuthUrl = (data) => get('/r4/juliang-dev/authUrl', data)


/**
  * 巨量授权回调
  * @param {*} data
  * @returns
  */
export const juliangDevCallback = (data) => get('/r4/juliang-dev/callback', data)


/**
  * 授权记录查询：仅当前授权人（生成授权链接的人）可见
  * @param {*} data
  * @returns
  */
export const juliangDevAuthRecords = (data) => get('/r4/juliang-dev/authRecords', data)



/**
  * 新增共享：把开发者账户共享给内部部门
  * @param {*} data
  * @returns
  */
export const juliangDevShareAdd= (data) => get('/r4/juliang-dev/share/add', data)



/**
  * 取消共享
  * @param {*} data
  * @returns
  */
export const juliangDevShareCancel = (data) => get('/r4/juliang-dev/share/cancel', data)



/**
  * 查询某开发者账户共享给了哪些部门
  * @param {*} data
  * @returns
  */
export const juliangDevShareInfo = (data) => get('/r4/juliang-dev/share/info', data)



/**
  * 修改开发者账户备注
  * @param {*} data
  * @returns
  */
export const juliangDevUpdateRemark = (data) => get('/r4/juliang-dev/updateRemark', data)


/**
  * 批量绑定子账户到指定授权记录
  * @param {*} data
  * @returns
  */
export const juliangDevBindAccounts = (data) => post('/r4/juliang-dev/bindAccounts', data)



/**
  * 分页查询某升级版工作台下已绑定的账户列表
  * @param {*} data
  * @returns
  */
export const juliangDevBindList = (data) => get('/r4/juliang-dev/bindList', data)